import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAEaXTbKtYXG5cbG7PPLu1ilEdm6atJL0U",
  authDomain: "sagetechapp.firebaseapp.com",
  projectId: "sagetechapp",
  storageBucket: "sagetechapp.firebasestorage.app",
  messagingSenderId: "232471932028",
  appId: "1:232471932028:web:b4b560886518fafb34edf9",
  measurementId: "G-8V3DG4BKNB",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
